import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css'
import RenderedPTags from "./leftSubMenuComponents/key.js";
import PieChart from "./leftSubMenuComponents/pieChart.js";
import ModifyPanel from "./leftSubMenuComponents/ModifyPanel.js";
import RenderedPTagsWithKey from "./leftSubMenuComponents/RenderedPTagsWithKey.js";
import AlterMetrics from './leftSubMenuComponents/alterMetrics.js';
import { IoMdClose } from "react-icons/io";

const LeftSubMenu = ({
  endDrawOnClick,
  endDrawCancelOnClick,
  isSelectingLandtypes,
  toggleLeftSubDrawer,
  isLeftSubDrawerOpen,
  handleLandtypePTagClick,
  selectedLandTypes,
  isViewingPieChart,
  longstandingGeoJSONRef,
  selectedYearEditing,
  isModifying,
  isComparing,
  selectedMetric,
  uniqueTextureNamesArray,
  isLanduse,
  polygonCustomLayerRef,
  isVisible,
  dropdownhighlightedIndex,
  setdropdownhighlightedIndex,
  setIsLanduse,
  piechartRef,
  handleEnlargePieButtonClick,
  comparingLandtypeSelectedOption,
  setcomparingLandtypeSelectedOption,
  resetLeftSubMenu,
  setisLeftSubDrawerOpen,
  storedfeaturecurrentlandtype,
  setStoredFeatureCurrentLandtype,
  temporaryGeoJSONIntendedForSaving,
  setTemporaryGeoJSONIntendedForSaving,
  setFinishedEditing,
  finishedEditing,
  universalParcelDifferentiator,
  universalColorPaletteName,
  hasChangedKeyValue,
  setHasChangedKeyValue,
  compareSelectedKey,
  setCompareSelectedKey,
  landKeySelectedKey,
  setLandKeySelectedKey,
  universalDataLoaded,
  handleLandtypePieHover,
  activeLayer,
  PDFpiechartRef,
  globalState,
  globalRefs
}) => {

  return (
    <div>
      <Drawer
        open={isLeftSubDrawerOpen}
        direction='left'
        className='leftSubMenu'
        enableOverlay={false}
        duration={250}
      >

        <div onClick={toggleLeftSubDrawer} className="leftSubMenu_cancel">
          <button>
            <IoMdClose />
          </button>
        </div>

        <div>
          {isSelectingLandtypes ? (
            <div className="genericSubMenuHelpBox">
              <div className="genericSubMenuHelpBoxinner">
                <h2>LAND KEY</h2>
                <div className='land_type_list_general'>
                  <RenderedPTags
                    selectedLandTypes={selectedLandTypes}
                    handleLandtypePTagClick={handleLandtypePTagClick}
                    uniqueTextureNamesArray={uniqueTextureNamesArray}
                    universalParcelDifferentiator={universalParcelDifferentiator}
                    selectedYearEditing={selectedYearEditing}
                    longstandingGeoJSONRef={longstandingGeoJSONRef}
                    universalColorPaletteName={universalColorPaletteName}
                    landKeySelectedKey={landKeySelectedKey}
                    setLandKeySelectedKey={setLandKeySelectedKey}
                    universalDataLoaded={universalDataLoaded}
                    activeLayer={activeLayer}
                  />
                </div>
              </div>
            </div>
          ) : (
            null
          )}
        </div>

        <div>
          {isViewingPieChart ? (
            <div className="genericSubMenuHelpBox">
              <div className="genericSubMenuHelpBoxinner">
                <h2>PIE CHART</h2>
                <div className="piechartdiv" style={{height: '100%'}}>
                  <PieChart
                    geojson={longstandingGeoJSONRef.current}
                    isViewingPieChart={isViewingPieChart}
                    selectedMetric={selectedMetric}
                    handleLandtypePTagClick={handleLandtypePTagClick}
                    polygonCustomLayerRef={polygonCustomLayerRef}
                    piechartRef={piechartRef}
                    handleEnlargePieButtonClick={handleEnlargePieButtonClick}
                    selectedYearEditing={selectedYearEditing}
                    universalParcelDifferentiator={universalParcelDifferentiator}
                    universalColorPaletteName={universalColorPaletteName}
                    landKeySelectedKey={landKeySelectedKey}
                    setLandKeySelectedKey={setLandKeySelectedKey}
                    handleLandtypePieHover={handleLandtypePieHover}
                    PDFpiechartRef={PDFpiechartRef}
                  />
                </div>
              </div>
            </div>
          ) : (
            null
          )}
        </div>

        <div>
          <div>
            {isModifying ? (
              <div className="genericSubMenuHelpBox">
                <div className="genericSubMenuHelpBoxinner">
                  <h2>BOUNDARIES</h2>
                  {isModifying &&
                    <ModifyPanel
                      endDrawOnClick={endDrawOnClick}
                      endDrawCancelOnClick={endDrawCancelOnClick}
                      selectedYearEditing={selectedYearEditing}
                      setFinishedEditing={setFinishedEditing}
                      finishedEditing={finishedEditing}
                    />}
                  <p>
                    <h3>MODIFYING A MAP</h3>
                    1 Click the polygon to Modify.<br />
                    2 Double-click the yellow points.<br />
                    3 Drag the points to your desired new shape.<br />
                    4 Double-click the polygon to finalise.<br />
                    <h3>ALLOCATING A NEW LANDTYPE</h3>
                    1 Click the "Draw" button located above.<br />
                    2 Click the map to create a new boundary.<br />
                    3 Continue clicking to draw the desired shape.<br />
                    4 Double-click to confirm the new boundary.<br />
                    5 Click the "Confirm" button to finalise.<br />
                    6 Select the new land type for the area.
                  </p>
                </div>
              </div>
            ) : (
              null
            )}
            {isComparing ? (
              <div className="genericSubMenuHelpBox">
                <div className="genericSubMenuHelpBoxinner">
                  <h2>COMPARE KEY</h2>
                  <p>
                    <RenderedPTagsWithKey
                      selectedLandTypes={selectedLandTypes}
                      handleLandtypePTagClick={handleLandtypePTagClick}
                      uniqueTextureNamesArray={uniqueTextureNamesArray}
                      setcomparingLandtypeSelectedOption={setcomparingLandtypeSelectedOption}
                      longstandingGeoJSONRef={longstandingGeoJSONRef}
                      selectedYearEditing={selectedYearEditing}
                      compareSelectedKey={compareSelectedKey}
                      setCompareSelectedKey={setCompareSelectedKey}
                      landKeySelectedKey={landKeySelectedKey}
                      setLandKeySelectedKey={setLandKeySelectedKey}
                    />
                  </p>
                </div>
              </div>
            ) : (
              null
            )}
            {isLanduse ? (
              <div className="genericSubMenuHelpBox">
                <div className="genericSubMenuHelpBoxinner">
                  <h2>UPDATE VALUES</h2>
                  <p style={{marginTop: '50px'}}>
                    1 Select the polygon on the map that you want to change the land use for<br />
                    2 From the :Metric Selection" dropdown choose the Metric you would like to update the values of.<br />
                    3 In the "Update Value" section Input or Select your new value.<br />
                    4 Click the 'Confirm' button to save the changes.<br />
                  </p>
                  <AlterMetrics
                    isVisible={isVisible}
                    polygonCustomLayerRef={polygonCustomLayerRef}
                    selectedYearEditing={selectedYearEditing}
                    dropdownhighlightedIndex={dropdownhighlightedIndex}
                    setdropdownhighlightedIndex={setdropdownhighlightedIndex}
                    longstandingGeoJSONRef={longstandingGeoJSONRef}
                    resetLeftSubMenu={resetLeftSubMenu}
                    setisLeftSubDrawerOpen={setisLeftSubDrawerOpen}
                    hasChangedKeyValue={hasChangedKeyValue}
                    setHasChangedKeyValue={setHasChangedKeyValue}
                    landKeySelectedKey={landKeySelectedKey}
                    setLandKeySelectedKey={setLandKeySelectedKey}
                    globalState={globalState}
                    globalRefs={globalRefs}
                  />
                </div>
              </div>
            ) : (
              null
            )}
          </div>
        </div>

        <button className='togglerDrawOutside' onClick={toggleLeftSubDrawer}>
          <IoIosArrowBack />
        </button>
      </Drawer>
    </div>
  );
};

export default LeftSubMenu;